import { useEffect, useMemo, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import MenuRow from './../MenuRow';
import StyledLoader from '../Loader';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';
import NoOptions from '../NoOptions';
import InfiniteScroll from 'react-infinite-scroll-component';
import useFetchList from '../../../../../../../../hooks/useFetchList';
import { uid } from '../../../../../../../FormikFields/ComplexSelect/SimpleSelect';
import { TABLE_KEYS, TABLE_NAMES } from '../../../../../../../../redux_store';

export const useStyles = makeStyles(theme => ({
  resultsContainer: {
    overflow: 'auto',
    height: 390,
    width: '100%',

    '& .infinite-scroll-component': {
      overflow: 'hidden !important',
    },
  },
  listContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

const AllOptions = ({
  selectedOptions = [],
  setSelectedOptions,
  dataKey,
  handleClose,
  open,
  tableName,
  searchValue,
  searchValueAll,
  showOnlyAvailableOptions,
  tableFilters,
  includeCurrentAccount = false,
  customAccountUuidForFilter = null,
}) => {
  const { accountUuid: paramAccountUuid } = useParams();
  const {
    metadata: { currentAccount },
  } = useSelector(state => state.user);
  const scrolableId = uid();
  const scrolableIdAll = scrolableId + 'All';
  const _urlEnd = useMemo(() => {
    switch (tableName) {
      case TABLE_NAMES[TABLE_KEYS.patientsPopulationHealthTable]: {
        return TABLE_NAMES[TABLE_KEYS.alertsTable];
      }
      case TABLE_NAMES[TABLE_KEYS.allowedAccountsTable]: {
        return TABLE_NAMES[TABLE_KEYS.accountsTable];
      }
      default: {
        return tableName;
      }
    }
  }, [tableName]);

  const othersFieldsFilters = tableFilters.filter(({ id }) => id !== dataKey);

  const {
    items,
    totalCount,
    loading: dataLoading,
    onLoadMoreRows,
    onMultiColumnFilter,
  } = useFetchList({
    baseEndpoint: `/accounts/${
      customAccountUuidForFilter || paramAccountUuid || currentAccount.uuid
    }/lookups/${_urlEnd}`,
    baseParams: { fields: [dataKey], includeCurrentAccount: includeCurrentAccount },
    canLoad: true,
  });

  const {
    items: itemsAll,
    totalCount: totalCountAll,
    loading: dataLoadingAll,
    onLoadMoreRows: onLoadMoreRowsAll,
    onMultiColumnFilter: onMultiColumnFilterAll,
  } = useFetchList({
    ignorePrefilters: true,
    baseEndpoint: `/accounts/${
      customAccountUuidForFilter || paramAccountUuid || currentAccount.uuid
    }/lookups/${_urlEnd}`,
    baseParams: { fields: [dataKey], includeCurrentAccount: includeCurrentAccount },
    canLoad: true,
  });

  useEffect(() => {
    onMultiColumnFilter([...othersFieldsFilters, { id: dataKey, value: searchValue }], true);
  }, [searchValue]);

  useEffect(() => {
    onMultiColumnFilterAll([{ id: dataKey, value: searchValueAll }], true);
  }, [searchValueAll]);

  useEffect(() => {
    if (open) {
      if (showOnlyAvailableOptions) {
        onMultiColumnFilter([...othersFieldsFilters, { id: dataKey, value: '' }], false);
      } else {
        onMultiColumnFilterAll([{ id: dataKey, value: '' }], false);
      }
    }
  }, [open]);

  const onOptionCheckboxClick = (option, checked) => {
    if (checked) {
      setSelectedOptions([...selectedOptions, option]);
    } else {
      setSelectedOptions(selectedOptions.filter(item => item !== option));
    }
  };

  return (
    <div>
      <div
        style={{
          width: '100%',
          height: '100%',
          display: showOnlyAvailableOptions ? 'flex' : 'none',
        }}
      >
        <_Content
          items={items}
          totalCount={totalCount}
          dataLoading={dataLoading}
          onLoadMoreRows={onLoadMoreRows}
          scrolableId={scrolableId}
          selectedOptions={selectedOptions}
          onOptionCheckboxClick={onOptionCheckboxClick}
          handleClose={handleClose}
          othersFieldsFilters={[]}
        />
      </div>
      <div
        style={{
          width: '100%',
          height: '100%',
          display: !showOnlyAvailableOptions ? 'flex' : 'none',
        }}
      >
        <_Content
          items={itemsAll}
          totalCount={totalCountAll}
          dataLoading={dataLoadingAll}
          onLoadMoreRows={onLoadMoreRowsAll}
          scrolableId={scrolableIdAll}
          selectedOptions={selectedOptions}
          onOptionCheckboxClick={onOptionCheckboxClick}
          handleClose={handleClose}
          othersFieldsFilters={othersFieldsFilters}
        />
      </div>
    </div>
  );
};

const _Content = ({
  items,
  totalCount,
  dataLoading,
  onLoadMoreRows,
  selectedOptions,
  handleClose,
  scrolableId,
  onOptionCheckboxClick,
}) => {
  const classes = useStyles();
  const {
    en: { titles },
  } = useSelector(state => state.i18n);
  const hasOptionsFromApi = !!(items && items?.length);

  const [isLoadMore, setIsLoadMore] = useState(false);

  useEffect(() => {
    if (!dataLoading) {
      setIsLoadMore(false);
    }
  }, [dataLoading]);

  return (
    <div id={scrolableId} className={classes.resultsContainer}>
      <InfiniteScroll
        dataLength={totalCount || 0}
        next={() => {}}
        initialScrollY={10}
        scrollableTarget={scrolableId}
        onScroll={e => {
          if (e.target.scrollTop + 500 >= e.target.scrollHeight) {
            if (!dataLoading && onLoadMoreRows && (items || []).length < totalCount) {
              setIsLoadMore(true);
              onLoadMoreRows((items || []).length);
            }
          }
        }}
        hasMore={true}
        loader={isLoadMore ? <h4>Loading...</h4> : <></>}
      >
        {(!dataLoading || isLoadMore) &&
          items &&
          items.map(option => (
            <MenuRow
              option={option}
              selected={selectedOptions}
              onItemClick={onOptionCheckboxClick}
              applyCurrentFilter={e => handleClose(e, option)}
            />
          ))}
      </InfiniteScroll>
      {dataLoading && !isLoadMore && <StyledLoader />}
      {!dataLoading && !hasOptionsFromApi && <NoOptions title={titles.nothingFound} />}
    </div>
  );
};

export default AllOptions;
